import { Card } from "@/components/ui/card";

interface PaymentAmountProps {
  amount: number;
}

export function PaymentAmount({ amount }: PaymentAmountProps) {
  const gstAmount = amount * 0.1;
  const subtotal = amount - gstAmount;

  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: 'AUD',
      minimumFractionDigits: 2
    }).format(value);
  };

  return (
    <div className="space-y-2">
      <div className="flex justify-between items-center text-sm">
        <span className="text-muted-foreground">Subtotal:</span>
        <span>{formatCurrency(subtotal)}</span>
      </div>
      <div className="flex justify-between items-center text-sm">
        <span className="text-muted-foreground">GST (10%):</span>
        <span>{formatCurrency(gstAmount)}</span>
      </div>
      <div className="h-px bg-border my-2" />
      <div className="flex justify-between items-center">
        <span className="font-medium">Total Amount:</span>
        <span className="text-2xl font-bold">{formatCurrency(amount)}</span>
      </div>
      <p className="text-xs text-muted-foreground mt-2">
        * All prices are in Australian Dollars (AUD) and include GST
      </p>
    </div>
  );
}